<template>
  <div class="pay_vcode">
    <div class="pay_success">
      <img src="/static/img/payicon.png" class="pay_icon" />
    </div>
    <div class="vcode_card">
      <div class="vcode_phone">请验证手机号码</div>
      <div class="vcode_pass">我们将在此手机号绑定的微信上为您开通服务</div>
      <div class="vcode_bg">
        <div class="group border">
          <input
            type="tel"
            placeholder="手机号码"
            maxlength="11"
            ref="txtPhone"
            autocomplete="off"
            style="ime-mode:disabled"
            v-model.trim="order.customer_mobile"
          />
        </div>
        <div class="group">
          <input
            type="tel"
            ref="txtSmsCode"
            class="vcode-cont"
            name="verification_code"
            id="verification_code"
            placeholder="验证码"
            maxlength="6"
            minlength="6"
            v-model.trim="sms_code"
          />
          <span
            id="get_verification_code"
            :class="sending_class"
            ref="btnSend"
            @click="getCode('SMS')"
            :disabled="sending_code"
          >{{ sending_text }}</span>
        </div>
      </div>
      <div class="tips">
        <div class="yellow">温馨提示：</div>
        <p>1、请谨慎使用验证码，超限将无法接收到短信信息</p>
        <p>2、短信验证是为了后续能顺利进行问卷填写、合同签订，服务开通等步骤。</p>
      </div>
      <div class="voices">
        收不到短信验证码？使用
        <span :class="vms_color" @click="getCode('VMS')">语音验证码</span>
      </div>
      <div class="actions mt-50">
        <mt-button type="primary" @click="submitSmsCode">确定</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox, Button } from "mint-ui";

export default {
  name: "MobileVerify",
  data: () => ({
    order: {},
    sms_code: "",
    vms_color: "",
    channel: "",
    sending_code: false,
    sending_class: "get_vcode",
    sending_text: "获取验证码",
    loaded: false,
    timer: null,
    sendTime: 0
  }),
  computed: {},
  created() {
    this.loadDetail();
  },
  components: {
    "mt-button": Button
  },
  mounted: function() {
    this.setPageTitle("手机号验证");
  },
  methods: {
    // 获取验证码
    getCode(channel) {
      let iphone = this.order.customer_mobile;
      let myreg = /^1[0-9]{10}$/;
      let time = 60;
      // 验证手机号
      if (iphone === "") {
        this.toast("请输入你的手机号码!");
        return false;
      }
      if (!myreg.test(iphone)) {
        this.toast("请输入有效的手机号码!");
        return false;
      }
      if (this.vms_color === "disable") {
        return false;
      }
      // 获取验证码
      this.startCountdown(60); // 60秒不能重复发
      let self = this;
      this.channel = channel;
      this.sendSmsCode(iphone, this.order.order_no, channel, function(data) {
        if (data.code > 0) {
          if (data.code > 1) {
            self.toast(data.message);
          } else {
            if (data.code === 1) {
              time = 60;
            } else {
              time = data.countDown;
            }
            self.startCountdown(time); // data.countDown秒不能重复发
          }
        } else {
          self.toast(data.message);
          self.startCountdown(60); // data.countDown秒不能重复发
        }
      });
    },

    startCountdown(code) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      let countdown = code;
      if (countdown <= 0 || countdown === undefined) {
        this.sending_code = false;
        this.sending_class = "get_vcode";
        this.sending_text = "获取验证码";
        this.vms_color = "";
        countdown = 60;
      } else {
        this.sending_code = true;
        this.sending_class = "get_vcode_gray";
        this.sending_text = countdown + "秒";
        if (countdown === 60) {
          this.sendTime = parseInt(Date.now() / 1000);
        }
        var rightNow = parseInt(Date.now() / 1000);
        if (rightNow - this.sendTime >= 0) {
          countdown = 60 - (rightNow - this.sendTime + 1);
        } else {
          countdown = 0;
          this.vms_color = "disable";
        }
        let self = this;
        this.timer = setTimeout(function() {
          self.startCountdown(countdown);
        }, 1000);
      }
    },
    submitSmsCode() {
      let iphone = this.order.customer_mobile;
      let myreg = /^1[0-9]{10}$/;
      // 验证手机号
      if (iphone === "") {
        this.toast("请输入你的手机号码!");
        return false;
      }
      if (!myreg.test(iphone)) {
        this.toast("请输入有效的手机号码!");
        return false;
      }
      if (!this.sms_code || this.sms_code === "") {
        this.toast("请输入短信验证码!");
        return false;
      }
      let self = this;
      this.loading("正在校验...");
      this.verifySmsCode(
        this.order.customer_mobile,
        this.order.order_no,
        this.sms_code,
        this.channel,
        function(resp) {
          if (resp.code > 0) {
            if (resp.code === 20105) {
              MessageBox.confirm(resp.message).then(
                action => {
                  console.log(action);
                  if (action === "confirm") {
                  }
                },
                action => {}
              );
            } else {
              self.toast(resp.message);
            }
          } else {
            self.toast(resp.message);
            // 判断服务端返回的action
            if (resp.data.action === "TransList") {
              self.$router.replace({ name: "MyOrderList" });
              return;
            }
            self.$router.replace({
              name: resp.data.action,
              params: { id: self.order.order_no }
            });
          }
        }
      );
    },
    loadDetail() {
      this.loading("正在读取信息...");
      this.getOrderSimpleDetail(this.$route.params.id, order => {
        this.loaded = true;
        this.order = order;
      });
    }
  }
};
</script>

<style scoped>
/*加到vue内的独立样式   start*/
.pay_vcode {
  font-size: 14px;
  max-width: 500px;
  margin: auto;
  padding: 0 15px;
}
.pay_success {
  text-align: center;
  font-size: 15px;
  height: 44px;
  line-height: 44px;
  color: #439aff;
}
.pay_success .pay_icon {
  width: 18px;
  vertical-align: -3px;
  margin-right: 4px;
}
.vcode_card {
  padding: 25px 15px;
  background: #fff;
  border-radius: 6px;
}
.vcode_phone {
  font-size: 20px;
  color: #333;
  text-align: center;
}
.vcode_pass {
  font-size: 14px;
  color: #666;
  margin-top: 6px;
  text-align: center;
}
.vcode_bg {
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 2px;
  margin-top: 20px;
}
.group {
  height: 51px;
  line-height: 50px;
  overflow: hidden;
  padding: 0 15px;
}
.group.border {
  border-bottom: 1px solid #e2e2e2;
}
.group input {
  line-height: 24px;
  margin-top: 12px;
  display: block;
  width: 100%;
  color: #333;
  border: none;
  box-shadow: none;
  outline: none;
  text-align: left;
}
.group .vcode-cont {
  display: inline-block;
  width: 60%;
}
.get_vcode {
  width: 36%;
  float: right;
  text-align: right;
  color: #439aff;
}
.get_vcode_gray {
  color: #333;
  width: 36%;
  float: right;
  text-align: right;
}
.action {
  text-align: center;
  margin-top: 25px;
}
.submit {
  width: 180px;
  height: 44px;
  font-size: 15px;
  text-align: center;
  color: #fff;
  background: #439aff;
  border: none;
  outline: none;
  -webkit-appearance: none;
  border-radius: 2px;
  cursor: pointer;
}
.submit:active {
  background: #2b8cfa;
}
.tips {
  padding: 10px 0;
  font-size: 12px;
}
.yellow {
  color: #ff8a05;
}
.tips p {
  margin: 0;
  line-height: 18px;
  color: #999;
}
.voices {
  width: 270px;
  line-height: 18px;
  color: #999;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 8px;
}
.voices span {
  color: #089dff;
  padding-left: 0.5em;
}
.voices span.disable {
  color: #e2e2e2;
}
</style>



// WEBPACK FOOTER //
// src/views/sms/MobileVerify.vue